<template>
  <q-modal-layout>
    <q-toolbar slot="header">
      <q-toolbar-title>
        <b>{{ data.number }}</b> - {{ data.item_code }}
      </q-toolbar-title>
    </q-toolbar>

    <div class="q-pa-md">
      <!-- all editable fields as inputs -->
      <div v-for="field in ['item_code', 'name', 'remarks', 'quantity', 'specifications']" :key="field">
        <template v-if="field === 'item_code'">
          <div class="row q-mb-lg">
            <q-search type="text" v-model="data.item_code" placeholder="Item" @clear="clearItemCode" class="q-mr-md full-width" float-label="Item">
              <q-autocomplete :max-results="25" :min-characters="2" @search="search" @selected="selected(...arguments, data)" />
            </q-search>
          </div>
          <hr class="q-my-sm" />

        </template>
        <div v-else class="row q-mb-md">
          <div class="col-5 q-pr-sm">
            <q-input v-model="data[field]" :float-label="getFieldLabel(field)" :disabled="field === 'name' && data.has_item" />
          </div>

          <div class="col-1 q-pr-sm q-pt-lg">
            <q-btn size="sm" :color="data.updates[field] ? 'primary' : 'grey-4'" @click="acceptUpdte(field)" icon="mdi-arrow-left" />
          </div>

          <div class="col-5 q-pr-sm">
            <q-input v-model="data.updates[field]" :float-label="getString(null, 'Updated version', 'Bijgewerkt versie')" readonly disabled />
          </div>

          <div class="col-1 q-pt-lg">
            <q-btn size="sm" :color="data.updates[field] ? 'secondary' : 'grey-4'" @click="cancelUpdte(field)" icon="mdi-window-close" />
          </div>
        </div>
      </div>
    </div>

    <!-- modal footer -->
    <q-toolbar slot="footer" color="grey-3">
      <q-btn class="capitalize q-mr-md" :label="getString(null, 'Save', 'Opslaan')" color="primary" @click="save" :disable="!containsChanges" />
      <q-btn class="capitalize q-mr-md" :label="getString(null, 'Accept all updates', 'Accepteer alle updates')" color="primary" :disable="hasUpdates === false" @click="acceptUpdte(null, true)" />
      <q-btn class="capitalize q-mr-md" :label="getString(null, 'Close', 'Sluit')" color="secondary" @click="close" />
    </q-toolbar>
  </q-modal-layout>
</template>

<script>
import axios from 'axios';
import getString from '@/helpers/GetStrings';
import qs from 'qs';

export default {
  name: 'SparePartsDetailModal',
  props: {
    item: {
      type: Object,
      required: true
    },
    reference: {
      type: Number,
      rewuired: true
    }
  },
  data() {
    return {
      cancels: [],
      data: {
        is_active: true,
      },
      translation: {
        nl: {
          name: 'Naam',
          remarks: 'Opmerkingen',
          quantity: 'Aantal',
          specifications: 'Specificaties',
        },
        en: {
          name: 'Name',
          remarks: 'Remarks',
          quantity: 'Quantity',
          specifications: 'Specifications',
        }
      }
    };
  },
  methods: {
    getString,

    clearItemCode() {
      this.data.item_code = '';
      this.data.item_id = null;
    },

    async search(terms, done) {
      try {
        // Request items based on terms given
        const results = await this.axios.get(`item?autocomplete=${terms.toLowerCase()}`);

        // Map only the item names/labels... to the suggested array
        const suggested = results.data.items.map(item => ({
          label: item.code,
          id: item.id,
        }));

        // Suggested items found, return suggestions.
        if (suggested.length) {
          done(suggested);
        }

        // Since an error is thrown when no items are found in autocomplete -> promt new suggestion here.
      } catch (error) {
        done([]);
      }
    },

    selected(item, keyboard, data) {
      // Prevent adding on keyboard arrow down
      if (keyboard) return;

      data.item_id = item.id;
      data.item_code = item.label;

    },

    getFieldLabel(field) {
      return this.getString(null, this.translation.en[field], this.translation.nl[field]);
    },

    acceptUpdte(field, all = false) {
      if (all) {
        for (const key in this.data.updates) {
          if (this.data.updates[key]) {
            this.data[key] = this.data.updates[key];
            this.cancels.push(key);
          }
        }
        return;
      }
      if (this.data.updates && this.data.updates[field]) {
        this.data[field] = this.data.updates[field];
        this.cancels.push(field);
      }
    },

    cancelUpdte(field) {
      if (this.data.updates && this.data.updates[field]) {
        this.cancels.push(field);
        this.data.updates[field] = null;
      }
    },

    close() {
      this.$emit('close');
    },

    save() {
      const data = {
        name: this.data.name,
        remarks: this.data.remarks,
        quantity: this.data.quantity,
        specifications: this.data.specifications,
      }
      if (this.data.item_id) {
        data.item_id = this.data.item_id;
      }
      if (this.data.item_code) {
        data.item_code = this.data.item_code;

      }
      if (this.cancels.length > 0) {
        data.cancels = JSON.stringify(this.cancels);
      }
      axios.put(`spareparts/${this.reference}/item/${this.data.id}`, qs.stringify(data))
        .then(response => {
          console.log('Spare part saved successfully:', response.data);
          this.$q.notify({
            message: 'Spare part item saved successfully',
            position: 'top-right',
            timeout: 1000,
            color: 'positive',
          });

          this.$emit('update', this.data);
          this.close();
        })
        .catch(error => {
          console.error('Error saving spare part:', error);
        });
    }
  },

  computed: {
    hasUpdates() {
      return Object.values(this.data.updates).some(value => value !== null);
    },
    containsChanges() {
      return Object.keys(this.data).some(key => {
        if (key === 'updates') return false;
        return this.data[key] !== this.item[key];
      }) || this.cancels.length > 0;
    }
  },

  beforeMount() {
    this.data = JSON.parse(JSON.stringify(this.item));

    if (!this.data.updates) {
      this.data.updates = {
        name: null,
        item_code: null,
        remarks: null,
        quantity: null,
        specifications: null,
      };
    }
  },
};
</script>
